'use client';

import { Box, Container, Grid, Image, useMatches } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { FooterBottom } from './FooterBottom';
import { FooterNavbar } from './FooterNavbar';
export const Footer: React.FC = () => {
  const {
    width
  } = useViewportSize();
  const src = useMatches({
    base: '/assets/footer-mobile.svg',
    sm: '/assets/footer-tablet.svg',
    lg: '/assets/footer-bg.svg'
  });
  return <Box component="section" mt={48}>
      <Container fluid h="100%" p={0} pos="relative">
        <Image pos="absolute" h="100%" inset={0} src={src} alt="footer-bg" style={{
        zIndex: -1,
        objectFit: 'cover'
      }} />
        <Grid gutter={24}>
          <Grid.Col p={width < 600 ? 0 : ''} span={width <= 1440 ? 2 : 3}>
            {''}
          </Grid.Col>
          <Grid.Col span={{
          sm: 12,
          md: 9
        }} mb={-10}>
            <FooterNavbar />
          </Grid.Col>
          <Grid.Col p={width < 600 ? 0 : ''} span={{
          sm: 12,
          md: 3
        }} mb={-10}>
            <Image src="/assets/ava2.svg" alt="avatar" pos="absolute" w={width <= 1440 ? 230 : width > 1800 ? 350 : 270} visibleFrom="md" left={0} bottom={0} style={{
            zIndex: -1
          }} />
          </Grid.Col>
          <Grid.Col span={{
          sm: 12,
          md: 9
        }}>
            <FooterBottom />
          </Grid.Col>
        </Grid>
      </Container>
    </Box>;
};